// extracted by mini-css-extract-plugin
export default {"positionContainer":"CategoriesPage_positionContainer__vOeS0","positionBadge":"CategoriesPage_positionBadge__BCQEj","positionValue":"CategoriesPage_positionValue__Jo9HW"};